
import { useParams } from "react-router-dom"
import { useState, useEffect } from 'react'
import { Card, Container, Grid, Typography } from "@mui/material"
import Loading from "../../../../load/loading";
import api from "../../../../services/api";
import { useSelector } from 'react-redux';
import Date from "../../../../utils/date";
import HeaderSession from "../../../../utils/headerSession";
import TextoFormatado from "../../../../utils/textoFormatado";
import ResponseExpediente from "./responseExpediente";
import CreateObservacaoExpediente from "./createObservacaoExpediente";
import { makeStyles } from "@material-ui/core";
import NavLateral from "./navLateral";
import PreviewAnexos from "../../../../utils/PreviewAnexos";

const useStyles = makeStyles((theme) => ({
    grid1: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",

        [theme.breakpoints.up("md")]: {
            // width: '100%',
            height: "100%",
            position: "sticky",
            top: 70,
        },
    },
    grid2: {
        flexGrow: 1,
        marginLeft: 15,
        width: 500,
        zIndex: 1,
    },
}));

export default function GestExpediente({ element: component, ...rest }) {
    const classes = useStyles();
    let { id } = useParams()
    const [expediente, setexpediente] = useState('')
    const user = useSelector(state => state.account.user);
    const [update, setUpdate] = useState(false)

    const [previewFiles, setPreviewFiles] = useState([]);
    const [currentFileIndex, setCurrentFileIndex] = useState(0);
    const [previewOpen, setPreviewOpen] = useState(false);

    const handleOpenPreview = (documents, fileIndex = 0) => {
        const valid = documents.filter((d) => typeof d === "string" && d.trim() !== "");
        if (!valid.length) return;
        setPreviewFiles(valid);
        setCurrentFileIndex(fileIndex);
        setPreviewOpen(true);
    };

    const handleClosePreview = () => setPreviewOpen(false);

    const handleNavigate = (index) => {
        if (index >= 0 && index < previewFiles.length) {
            setCurrentFileIndex(index);
        }
    };

    useEffect(() => {
        api.get(`/expediente/${id}`)
            .then(response => {
                // console.log(response)
                setexpediente(response.data.expediente);
            }).catch(error => {
                // console.log(error)
                // if (error.response.status === 500) {
                //     setMessageError('Reclamação não encontrada')
                //     window.setTimeout(() => {
                //         navigate(-1)
                //     }, 1000);
                // }
            })
    }, [id, update])


    return (
        expediente
            ?

            <Container>
                <HeaderSession title={'GESTÃO DE EXPEDIENTE'} />

                <Grid container>
                    <Grid item className={classes.grid1}>
                        <NavLateral
                            observacoesFeitas={expediente?.observacoes}
                            expediente={expediente}
                            setUpdate={setUpdate}
                        />
                    </Grid>

                    <Grid xs item className={classes.grid2} style={{ marginLeft: 15 }}>
                        {/* {React.cloneElement(component, {
                                expediente: expediente,
                            })} */}


                        <Card style={{ padding: 20, marginBottom: 10, }}>
                            <Typography variant="body1" lineHeight={1.5}>
                                Número de Expediente: {expediente?.numero}
                                <br />
                                <strong>Tipo de documento:</strong> {expediente?.tipoDocumento?.designacao}
                                <br />
                                <strong>Assunto:</strong> {expediente?.assunto}
                                <br />
                                <strong>Nome:</strong> {expediente?.nome}
                                <br />
                                <strong>Contacto:</strong> {expediente?.tel}
                                <br />
                                <strong>Email:</strong> {expediente?.email}
                                <br />
                                <strong>Data:</strong> <Date date={expediente?.createdAt} />
                            </Typography>
                        </Card>

                        <Card style={{ padding: 20, marginBottom: 10, }}>
                            <Typography align="center" variant="body1" style={{ margin: 10 }}>
                                Exposição
                            </Typography>
                            <TextoFormatado texto={expediente?.descricao} />
                        </Card>

                        <Card style={{ padding: 20 }}>
                            <Typography variant="subtitle1" style={{ margin: 10 }}>
                                Documento anexado nº {expediente?.numeroDocumento}
                                <br />
                                <a target="_blank" onClick={(e) => {
                                    e.preventDefault();
                                    handleOpenPreview([expediente?.anexo], 0);
                                }}>{expediente?.anexo ? 'Anexo' : ''} </a>
                            </Typography>
                            <iframe
                                id="pdfIframeExpediente"
                                title={`PDF Viewer`}
                                src={[expediente?.anexo]}
                                width="100%"
                                height="700px"
                                style={{ border: 'none' }}
                            />
                        </Card>

                        <ResponseExpediente
                            userId={user?._id}
                            expediente={expediente}
                            setUpdate={setUpdate}
                        />

                        <CreateObservacaoExpediente
                            userId={user?._id}
                            expedienteId={id}
                            observacoes={expediente?.observacoes}
                            setUpdate={setUpdate}
                        />

                    </Grid>
                </Grid>

                <PreviewAnexos
                    files={previewFiles}
                    currentIndex={currentFileIndex}
                    isOpen={previewOpen}
                    onClose={handleClosePreview}
                    onNavigate={handleNavigate}
                />

            </Container>
            :
            <Loading text={'A carregar expediente.'} />
    )
}